module.exports = __webpack_public_path__ + "media/images/athletes/4154-c580027673dc154377c192578fb2d359.png";